export default __webpack_public_path__ + "static/project-create-standard-bd3516011e9bcf3edb0cedac55510f72.png";